module.exports = __webpack_public_path__ + "static/acc-451067c012c7a7b44dd9141f80d3b391.jpg";